var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-2",attrs:{"color":"blue-grey","outlined":""},on:{"click":_vm.back}},[_c('v-icon',{attrs:{"color":"#7B96A3"}},[_vm._v("mdi-arrow-left")]),_vm._v(_vm._s(_vm.text))],1)}
var staticRenderFns = []

export { render, staticRenderFns }